export enum StorageKeys {
    PaperCompanyValues = "PaperCompanyValues",
    PaperCompanySettings = "PaperCompanySettings"
}
